import React, {createContext, useContext, useState} from 'react';
import PropTypes from 'prop-types';

const DeliveryHoursContext = createContext();
const DeliveryHoursContextUpdate = createContext();

export const useDeliveryHoursContext = () => {
  return useContext(DeliveryHoursContext);
};

export const useDeliveryHoursContextUpdate = () => {
  return useContext(DeliveryHoursContextUpdate);
};
export const DeliveryHoursContextProvider = ({children}) => {
  DeliveryHoursContextProvider.propTypes = {
    children: PropTypes.objectOf(PropTypes.any)
  };

  DeliveryHoursContextProvider.defaultProps = {
    children: {}
  };

  const [deliveryDays, setDeliveryDays] = useState([]);

  const updateDeliveryDays = (arr) => {
    setDeliveryDays(arr);
  };

  return (
    <DeliveryHoursContext.Provider value={deliveryDays}>
      <DeliveryHoursContextUpdate.Provider value={updateDeliveryDays}>
        {children}
      </DeliveryHoursContextUpdate.Provider>
    </DeliveryHoursContext.Provider>
  );
};
